import src from "IMAGE";
export default { src, width: 1427, height: 120, blurWidth: 0, blurHeight: 0};
